import { render, staticRenderFns } from "./openResourceManage.vue?vue&type=template&id=2744c048&scoped=true"
import script from "./openResourceManage.vue?vue&type=script&lang=js"
export * from "./openResourceManage.vue?vue&type=script&lang=js"
import style0 from "./openResourceManage.vue?vue&type=style&index=0&id=2744c048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744c048",
  null
  
)

export default component.exports